<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>Ticket Import Sendungen (csv)</li>
    </ul>
  </div>
</div>

<div class="page-content overflow-y-auto px-4">
  <div class="bg-base-100 w-full max-w-7xl mx-auto p-4 border border-base-300 rounded-box flex flex-col">
    <p>
      gültige Felder: <br />
      - ticket_id (z.B: MI-20-044100)<br />
      - carrier (z.B. UPS, DHL)<br />
      - sendungsnummer (z.B. 1Z6932186861573064 )<br />
      - versandatum (z.B. 14.08.20)<br />
      - empfangsplz (z.B. 24251)
      <br />
      <br /><br />

      Upload im <b>csv</b>-Format
    </p>

    @switch (status) {
      @case ("new") {
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="w-full max-w-80 self-center">
          <fieldset class="w-full bm-fieldset">
            <legend class="bm-fieldset-legend">Import Datei auswählen</legend>
            <input type="file" class="bm-file-input w-full" name="importfile" (change)="onFileChange($event)" />
            <button class="bm-btn bm-btn-primary bm-btn-block mt-2" type="submit">Upload</button>
          </fieldset>
        </form>
      }
      @case ("running") {
        <h3>Import läuft, bitte warten!</h3>
      }
      @case ("done") {
        <h3>Abgeschlossen!</h3>
        @if (errorIds?.length) {
          <div role="alert" class="bm-alert bm-alert-error bm-alert-soft bm-alert-vertical sm:bm-alert-horizontal">
            <span></span>
            <div>
              <div class="font-bold text-lg">Abgeschlossen mit Fehler! (anz.: {{ errorIds.length }})</div>
              <div class="text-xs">Fehlerhafte ids: {{ errorIds | json }} log: {{ errorLog | json }}</div>
            </div>
            <button class="bm-btn bm-btn-sm bm-btn-error" (click)="status = 'new'">nochmal benutzen</button>
          </div>
        } @else {
          <div role="alert" class="bm-alert bm-alert-success bm-alert-soft bm-alert-vertical sm:bm-alert-horizontal">
            <span></span>
            <div>
              <div class="font-bold text-lg">Abgeschlossen</div>
            </div>
            <button class="bm-btn bm-btn-sm bm-btn-error" (click)="status = 'new'">nochmal benutzen</button>
          </div>
        }
      }
      @case ("error") {
        <div role="alert" class="bm-alert bm-alert-error bm-alert-soft bm-alert-vertical sm:bm-alert-horizontal">
          <span></span>
          <div>
            <div class="font-bold text-lg">Fehler!</div>
            <div class="text-xs">{{ errorText }}</div>
          </div>
          <button class="bm-btn bm-btn-sm bm-btn-error" (click)="status = 'new'">nochmal benutzen</button>
        </div>
      }
    }
  </div>
</div>
